// frontend/src/features/bans/bansSlice.js
/**
 * Phase 6: Ban audit read model for UPS banned list.
 * Source of truth: GET /api/ups/drivers/banned
 * Reads existing UI filters from state.ui.filters (agencyId, q, source).
 */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchBannedDrivers } from '../../services/upsDriverService';

export const loadBannedDrivers = createAsyncThunk(
  'bans/loadBannedDrivers',
  async (_, { getState }) => {
    const state = getState();
    const agencyId = state.ui?.filters?.agencyId || '';
    const search   = state.ui?.filters?.q || '';
    const source = state.ui?.filters?.source || 'all';

    return await fetchBannedDrivers({ agencyId, search, source });
  }
);

const bansSlice = createSlice({
  name: 'bans',
  initialState: {
    rows: [],
    loading: false,
    error: null,
    lastLoaded: null,
  },
  reducers: {
    setBans(state, action) {
      state.rows = Array.isArray(action.payload) ? action.payload : [];
    },
  },
  extraReducers(builder) {
    builder
      .addCase(loadBannedDrivers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loadBannedDrivers.fulfilled, (state, action) => {
        state.loading = false;
        state.rows = action.payload || [];
        state.lastLoaded = Date.now();
      })
      .addCase(loadBannedDrivers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || 'Failed to load banned drivers';
      });
  },
});

export const { setBans } = bansSlice.actions;
export default bansSlice.reducer;

export const selectBannedRows     = (s) => s.bans?.rows || [];
export const selectBansLoading    = (s) => !!s.bans?.loading;
export const selectBansError      = (s) => s.bans?.error || null;
